/**
 * Adapted from reporting_app/web/src/hooks/useAccessiblePages.ts: reads off
 * AuthContext's already-fetched `user.accessiblePages` — no separate
 * network call. Used by Layout.tsx to filter the nav to pages the user can view.
 */
import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import type { AccessiblePage } from '../types/auth';

export function useAccessiblePages(): { pages: AccessiblePage[]; isLoading: boolean } {
  const { user, loading } = useAuth();
  return useMemo(() => ({ pages: user?.accessiblePages ?? [], isLoading: loading }), [user, loading]);
}
